import { CENTRAL_MONITORING_WINDOW_NAME, INDIVIDUAL_MONITORING_WINDOW_NAME } from '../components/monitoring/cctvPopupRoutes';

/** 메뉴·관제실에서 연 통합/개별 관제 팝업 창 */
export function isCentralMonitoringPopupWindow(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.name === CENTRAL_MONITORING_WINDOW_NAME) return true;
  if (
    typeof window.name === 'string' &&
    window.name.startsWith(`${INDIVIDUAL_MONITORING_WINDOW_NAME}_`)
  ) {
    return true;
  }
  try {
    return Boolean(window.opener && !window.opener.closed);
  } catch {
    return false;
  }
}
